module.exports = __webpack_public_path__ + "static/media/pic3.3f71c619.jpg";